var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Solicitudes",attrs:{"id":"repairs"}},[_c('card-wrapper',{attrs:{"id":"repairs-card","title":_vm.$t('title.repairs') || 'Reparaciones',"hide-close-btn":true,"show-divider":true}},[_c('repairs-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }